<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  @let orientation = (orientation$ | async)!;
  <ng-container>
    <!-- eslint-disable @angular-eslint/template/no-call-expression -->
    <div
      *ngFor="let item of settings?.general?.menuAnimatedItems ?? []; let i = index; trackBy: trackByIndex"
      class="image"
      [class.selected]="selectedItem === i"
      [style.background-image]="getBackgroundImageSrc(item, orientation)">
    </div>
    <!-- eslint-enable @angular-eslint/template/no-call-expression -->
  </ng-container>
  <div class="menu">
    <render-link
      *ngFor="let item of settings?.general?.menuAnimatedItems ?? []; let i = index; trackBy: trackByIndex"
      [lang]="lang"
      [link]="item.categoryId | getCategoryLink : piece?.name : country : lang"
      (mouseover)="setSelectedItem(i)"
      (touchstart)="setSelectedItem(i)">
      <render-wysiwyg
        [html]="item.text"
        [country]="country"
        [lang]="lang"
        [piece]="piece"
        [class.selected]="selectedItem === i">
      </render-wysiwyg>
    </render-link>
  </div>
</idt-common-styles-render>
